import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

//models
import {SlxAdminUsersModel} from '../model/slx-admin-users.model';

// service
import {CustomHttp} from '../../core/http-custom/http-custom.service';
import {HttpParams} from "@angular/common/http";

@Injectable()
export class SlxAdminUsersService {

  constructor(
    private _http: CustomHttp
  ) {
  }

  public searchUsers(searchParams: HttpParams): Observable<Array<SlxAdminUsersModel>> {
    return this._http.get('/apps/umng/user', null, searchParams);
  }

  public loadAssignedCountries(): Observable<Array<SlxAdminUsersModel>> {
    return this._http.get('/apps/umng/api/user/assignedCountries');
  }

}
